/**
 * @module prettyFileSize
 * @since 2.6.0
 */

const K = 1024;
const SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/**
 * Generate a pretty file size from bytes, based on impl from https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
 *
 * @param  {Number}  bytes - size in bytes.
 * @param  {Integer} [mantissaSize=2] - amount of numbers to show after decimal point.
 * @return {String}  pretty file size in the closest measurement unit.
 *
 * @example prettyFileSize(0);
 * // "0 Bytes"
 *
 * @example prettyFileSize(1800);
 * // "1.76 KB"
 *
 * @example prettyFileSize(18000000, 1);
 * // "17.2 MB"
 */

export function prettyFileSize(bytes, mantissaSize = 2) {
    if (bytes === 0) { return '0 Bytes'; }
    const dm = mantissaSize <= 0 ? 0 : mantissaSize,
        i = Math.floor(Math.log(bytes) / Math.log(K));

    return `${parseFloat((bytes / Math.pow(K, i)).toFixed(dm))} ${SIZES[i]}`;
}
